export type BundleConditionType = 'CENTER_ALL' | 'CENTER_BARCODE' | 'ALL_CENTER_BARCODE' | 'CENTER_SKU' | 'ALL_CENTER_SKU'

// BE 판정 축 flag 와 같은 키다 (SinglePackRules.FEATURE_KEY_SKU_AXIS).
// 등록 화면 축이 판정 축과 갈리면 등록한 조건을 판정 로더가 읽지 않는다 (SinglePackageConditionLoader2)
export const SINGLE_PACK_SKU_AXIS_FLAG = 'feature.outboundSinglePack.skuAxis' as const

export interface SingleBatchSettingItem {
  id: number
  warehouseCode: string | null
  conditionType: BundleConditionType
  status: 'ACTIVE' | 'INACTIVE'
  startAt: string
  endAt: string
  barcodes: string[]
  barcodeCount: number | null
  createdAt: string
  createdBy: string
}

export interface GetSingleBatchSettingsReq {
  warehouseCode?: string
  barcodes?: string[]
  page?: number
  size?: number
}

export interface CreateBundleConditionReq {
  warehouseCode: string | null
  // CENTER_SKU 는 이 API 가 422 로 거절한다 — /sku 로 보낸다
  conditionType: Exclude<BundleConditionType, 'CENTER_SKU'>
  startAt: string
  endAt: string
  barcodes?: string[]
}

export interface CreateBundleConditionSkuReq {
  warehouseCode: string
  startAt: string
  endAt: string
  skuIds: string[]
}

export interface UploadBundleConditionsExcelReq {
  file: File
  startAt: string
  endAt: string
  warehouseCode?: string
}

export interface UploadBundleConditionsExcelErrorData {
  errorRows: number[]
}
